import { Column } from '@miq/catalog';
import { EntityType } from '@shared/models/entity-enum';

export class ToggleShowFavorites {
  static readonly type = '[FormState] ToggleShowFavorites';
  constructor(
    public entity: EntityType,
    public showFavorites: boolean
  ) {}
}

export class ToggleBeastMode {
  static readonly type = '[FormState] ToggleBeastMode';
  constructor(public entity: EntityType) {}
}

export class SetActiveEntity {
  static readonly type = '[FormState] SetActiveEntity';
  constructor(
    public entity: EntityType,
    public isCreateMode: boolean
  ) {}
}

export class SetFavoritesAction {
  static readonly type = '[FormState] SetFavorites';
  constructor(public favorites: number[]) {}
}

export class ToggleFavoriteAction {
  static readonly type = '[FormState] ToggleFavoriteAction';
  constructor(public column: Column) {}
}

export class ToggleCollapseAll {
  static readonly type = '[FormState] CollapseAll';
  constructor(
    public entity: EntityType,
    public sectionIds: string[]
  ) {}
}

export class ToggleExpansion {
  static readonly type = '[FormState] ToggleExpansion';
  constructor(public sectionId: number) {}
}

export class ExpandSections {
  static readonly type = '[FormState] ExpandSections';
  public sectionIds: number[];

  constructor(...sectionIds: number[]) {
    this.sectionIds = sectionIds;
  }
}

export class RegisterSections {
  static readonly type = '[FormState] RegisterSections';
  constructor(public sectionId: number) {}
}
